module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/da5eda28f6ce98ebf6c9ba47e5c52d50.png";